var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('SForm',{ref:"formref",attrs:{"url":_vm.formurl,"method":"put","fields":_vm.formfields,"dataForm":_vm.rowdata,"before":_vm.formbefore,"handle":_vm.formhandle,"labelWidth":"150px","inline":false,"formStyle":"width: 400px;"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7f9f57e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BMS/userManagement/addAdministrators.vue
// module id = null
// module chunks = 